var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config_list != "" || _vm.calendarList != ""
    ? _c("div", { staticClass: "livetip-wrapper2" }, [
        _c(
          "div",
          { staticClass: "tab-group-box", on: { click: _vm.go_detail } },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", {
              staticClass: "tab-group-right",
              attrs: { src: "../../../static/images/group-tab-more.png" }
            })
          ]
        ),
        _vm._v(" "),
        _vm.config_flag
          ? _c("div", { staticClass: "config_mask" }, [
              _c("div", { staticClass: "config_content" }, [
                _c("p", { staticClass: "config_title" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/images/guanbi.png")
                    },
                    on: {
                      click: function($event) {
                        _vm.config_flag = false
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "config_detail" },
                  _vm._l(_vm.courseLists.wx_list, function(i) {
                    return _c("div", { staticClass: "out_loop" }, [
                      _c("p", { staticClass: "cid_name" }, [
                        _vm._v(_vm._s(i.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "warn_mes" }, [
                        _vm._v(_vm._s(i.remark))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "weixin_img" }, [
                        _c("img", {
                          staticClass: "img_link",
                          attrs: { src: i.qr }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "hand",
                          attrs: {
                            src: require("../../../static/images/hand.png")
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.isweixin
                        ? _c("p", { staticClass: "wenan" }, [
                            _vm._v("微信扫码 邀你进群")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isweixin
                        ? _c(
                            "div",
                            {
                              staticClass: "go_wxapp_btn",
                              on: {
                                click: function($event) {
                                  return _vm.goWxapp(i.qr)
                                }
                              }
                            },
                            [_vm._v(_vm._s(i.button_name || "点击添加微信"))]
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "config_detail" },
                  _vm._l(_vm.courseList.qq_list, function(i) {
                    return _c("div", [
                      _c("p", { staticClass: "cid_name" }, [
                        _vm._v(_vm._s(i.remark))
                      ]),
                      _vm._v(" "),
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "qq_config" }, [
                        _c("div", { staticClass: "qq_group" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../static/images/qq_group.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "qq_name" }, [
                            _c("p", [_vm._v("QQ群号")]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(i.qq))])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "qq_text",
                          attrs: { type: "text" },
                          domProps: { value: i.qq }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "copy", on: { click: _vm.copy_text } },
                          [_vm._v("复制QQ群号")]
                        )
                      ])
                    ])
                  }),
                  0
                )
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-group-left" }, [
      _c("img", {
        staticClass: "tab-group-add",
        attrs: { src: require("../../../static/images/add.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "tab-group-txt" }, [
        _vm._v("添加专属助教，获取优质资料/方法分享")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "warn_mes" }, [
      _vm._v("为确保您正常听课，请务必尽快加群下载课程资料"),
      _c("br"),
      _vm._v("班群解散后不再提供资料")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3be433c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3be433c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/group/index.vue
// module id = null
// module chunks = 